/** @jsx jsx */
import { css, jsx } from "@emotion/core"

export function PlayerTimeDisplay({
  lengthInSeconds,
  timeElapsedInSeconds,
  className,
}: {
  lengthInSeconds: number
  timeElapsedInSeconds: number
  className?: string
}) {
  function formatTime(time: number) {
    if (isNaN(time)) {
      return
    }
    const date = new Date(0)
    date.setSeconds(time)
    return date.toISOString().substr(14, 5)
  }

  return (
    <div
      css={css`
        -webkit-text-size-adjust: 100%;
        font-family: inherit;
        font-variant-numeric: tabular-nums;
        font-weight: 400;
        line-height: 1.7;
        text-shadow: none;
        text-align: center;
        color: white;
        box-sizing: inherit;
        font-size: 13px;
        margin-left: 3px;
        padding: 0 5px;
        white-space: nowrap;
        letter-spacing: -0.5px;
      `}
      className={className}
    >
      {formatTime(timeElapsedInSeconds)} / {formatTime(lengthInSeconds)}
    </div>
  )
}
